import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'W7',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M26.18 24.22v-3.19A5.808 5.808 0 0 0 29.09 16c0-3.21-2.6-5.82-5.82-5.82-1.16 0-2.24.35-3.15.94-.9-3.87-4.35-6.76-8.48-6.76-4.82 0-8.73 3.91-8.73 8.73 0 2.58 1.13 4.89 2.91 6.49v3.58C2.34 21.14 0 17.4 0 13.09 0 6.66 5.21 1.45 11.64 1.45c4.37 0 8.17 2.41 10.16 5.97.48-.08.97-.15 1.48-.15C28.09 7.27 32 11.18 32 16c0 3.8-2.43 7.02-5.82 8.22zm-16-5.31a1.451 1.451 0 0 1 0 2.9 1.451 1.451 0 0 1 0-2.9zm0 5.82a1.451 1.451 0 0 1 0 2.9 1.451 1.451 0 0 1 0-2.9zM16 21.82a1.451 1.451 0 0 1 0 2.9 1.451 1.451 0 0 1 0-2.9zm0 5.82a1.451 1.451 0 0 1 0 2.9 1.451 1.451 0 0 1 0-2.9zm5.82-8.73a1.451 1.451 0 0 1 0 2.9c-.8 0-1.45-.65-1.45-1.45-.01-.8.65-1.45 1.45-1.45zm0 5.82a1.451 1.451 0 0 1 0 2.9c-.8 0-1.45-.65-1.45-1.45-.01-.8.65-1.45 1.45-1.45z" }
      })]
    );
  }
};